//Auth action types
export const LOGIN="LOGIN";
export const LOGOUT="LOGOUT";
export const AUTHENTICATE="AUTHENTICATE";
export const AUTHENTICATION_FAILED="AUTHENTICATION_FAILED";
export const AUTHENTICATION_SUCCESS="AUTHENTICATION_SUCCESS";
export const RESET_PASSWORD="RESET_PASSWORD";
export const PASSWORD_RESET_REQUEST_SUCCESS="PASSWORD_RESET_REQUEST_SUCCESS";
export const PASSWORD_RESET_REQUEST_ERROR="PASSWORD_RESET_REQUEST_ERROR";
export const PASSWORD_RESET_ERROR="PASSWORD_RESET_ERROR";
export const PASSWORD_RESET_SUCCESS="PASSWORD_RESET_SUCCESS";
export const PASSWROD_RESET_MODE="PASSWRD_RESET_MODE";
export const ACCOUNT_UPDATED="ACCOUNT_UPDATED";
//UI Action types
export const LOAN_UPDATED="LOAN_UPDATED";
export const SHOW_MESSAGE="SHOW_MESSAGE";
export const HIDE_MESSAGE="HIDE_MESSAGE";
export const CONFIRM_ACTION="CONFIRM_ACTION";
export const ACTION_CONFIRMED_OR_CANCELED="ACTION_CONFIRMED_OR_CANCELED";
export const SET_INBOX_COUNT="SET_INBOX_COUNT";
export const SET_DATES_COUNT="SET_DATES_COUNT";
export const EMAIL_READ="EMAIL_READ";
export const USER_ACCOUNT_UPDATED="USER_ACCOUNT_UPDATED";
export const ADD_SERVICER="ADD_SERVICER";
export const UPDATE_SERVICER="UPDATE_SERVICER";
export const LOAD_SERVICERS="LOAD_SERVICERS";

export const LOAD_FORMS="LOAD_FORMS";
export const ADD_FORM="ADD_FORM";
export const UPDATE_FORM="UPDATE_FORM";